/**
 * יומן הורדות ייצוא שיחה לאקסל — נשמר ב-localStorage בדפדפן הנוכחי בלבד.
 * תצוגה בלבד בהגדרות מערכת; אין השפעה על שליחה / היסטוריה / סוקט.
 */

export type ChatExportLogEntry = {
  id: string;
  /** ISO timestamp */
  exportedAt: string;
  exporterUserId?: string | null;
  exporterName: string;
  contactName: string;
  contactPhone: string;
  fileName: string;
  messageCount: number;
};

const STORAGE_KEY = 'funner.chatExportDownloadsJournal.v1';
const MAX_ENTRIES = 500;

function safeParse(raw: string | null): ChatExportLogEntry[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (row): row is ChatExportLogEntry =>
        Boolean(row) &&
        typeof row === 'object' &&
        typeof (row as ChatExportLogEntry).id === 'string' &&
        typeof (row as ChatExportLogEntry).exportedAt === 'string',
    );
  } catch {
    return [];
  }
}

export function readChatExportDownloadsJournal(): ChatExportLogEntry[] {
  try {
    return safeParse(localStorage.getItem(STORAGE_KEY));
  } catch {
    return [];
  }
}

export function appendChatExportDownloadEntry(
  entry: Omit<ChatExportLogEntry, 'id' | 'exportedAt'> & {
    id?: string;
    exportedAt?: string;
  },
): ChatExportLogEntry {
  const full: ChatExportLogEntry = {
    id: entry.id ?? `cex-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    exportedAt: entry.exportedAt ?? new Date().toISOString(),
    exporterUserId: entry.exporterUserId ?? null,
    exporterName: entry.exporterName?.trim() || 'לא ידוע',
    contactName: entry.contactName?.trim() || 'ללא שם',
    contactPhone: entry.contactPhone?.trim() || '',
    fileName: entry.fileName?.trim() || '',
    messageCount: Number.isFinite(entry.messageCount) ? entry.messageCount : 0,
  };

  try {
    const prev = readChatExportDownloadsJournal();
    const next = [full, ...prev].slice(0, MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // מכסה מלא / מצב פרטי — לא לשבור את ההורדה
  }

  return full;
}

export function clearChatExportDownloadsJournal(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
